import {
  required,
  unique,
  shape,
  items,
  concatFailure,
  when,
  logTo,
  stopOnFirstFailure,
  greaterThan,
  fromModel,
  lessThan,
  Success, Failure, ValidationError,
  Validator
} from '@totalsoft/pure-validations';
import i18next from 'i18next';

const validatorScoringCategoryDefaultDetails = 
 Validator(
    list => {
      if (list === null || list === undefined) {
        return Success;
      }
  return list.filter(item => item.defaultYN && item.defaultYN === true).length <= 1
    ? Success
    : Failure(ValidationError(i18next.t('ScoringCategories.Details.Validators.DefaultYN')));
});

export const scoringCategoryValidator =
  shape({
    orderNo: required,
    scoringCode: required,
    scoringName: required
  })
 |> logTo(console);

export const scoringCategoryDetailValidator = visibleNumeric => {
  return (
    concatFailure(
      validatorScoringCategoryDefaultDetails,
      unique(x => x.orderNo || {}, 'ScoringCategories.Details.Validators.OrderNoUnique'),
      unique(x => x.code || {}, 'ScoringCategories.Details.Validators.CodeUnique'),      
      items(
        fromModel(model =>
          shape({
            orderNo: required,
            code: required,
            scoringDetailName: required,
            minValue:
              [required |> when(visibleNumeric === 2), lessThan(model.maxValue) |> when(Boolean(model.maxValue) && visibleNumeric === 2)]
              |> stopOnFirstFailure, //aici trebuie in functie de conditie din header,
            maxValue:
              [required |> when(visibleNumeric === 2), greaterThan(model.minValue) |> when(Boolean(model.minValue) && visibleNumeric === 2)]
              |> stopOnFirstFailure, //aici trebuie in functie de conditie din header
            score: required
          })
        )
      )
    ) |> logTo(console)
  );
};
